import { Colors, Fonts, breakpoint, Emphasis } from '@estee/elc-base-theme';

export const DarkClassName = 'elc-dark-theme';

const commonCss = `
    margin: 0;
    color: rgba(0, 0, 0, ${Emphasis.high.value});

    &.${Emphasis.medium.className} {
        color: rgba(0, 0, 0, ${Emphasis.medium.value});
    }

    &.${Emphasis.disabled.className} {
        color: rgba(0, 0, 0, ${Emphasis.disabled.value});
    }

    &.${DarkClassName} {
        color: ${Colors.white};

        &.${Emphasis.medium.className} {
            color: rgba(255, 255, 255, ${Emphasis.medium.value});
        }

        &.${Emphasis.disabled.className} {
            color: rgba(255, 255, 255, ${Emphasis.disabled.value});
        }
    }
`;

export const heading1Theme = () => `
    font-family: ${Fonts.robotoLight};
    font-size: 28px;
    font-weight: 300;
    letter-spacing: -0.23px;
    line-height: 36px;
    ${commonCss}

    ${breakpoint('desktop')`
        font-size: 48px;
        letter-spacing: -0.4px;
        line-height: 60px;
    `}

`;

export const heading2Theme = () => `
    font-family: ${Fonts.robotoMedium};
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    ${commonCss}
    
    ${breakpoint('desktop')`
        font-family: ${Fonts.roboto};
        font-size: 36px;
        font-weight: normal;
    `}
`;

export const heading3Theme = () => `
    font-family: ${Fonts.roboto};
    font-size: 20px;
    font-weight: normal;
    letter-spacing: 0.15px;
    line-height: 24px;
    ${commonCss}

    ${breakpoint('desktop')`
        font-size: 28px;
        letter-spacing: 0.21px;
        line-height: 32px;
    `}
`;

export const heading4Theme = () => `
    font-family: ${Fonts.roboto};
    font-size: 18px;
    font-weight: normal;
    letter-spacing: 0.16px;
    line-height: 24px;
    ${commonCss}

    ${breakpoint('desktop')`
        font-size: 24px;
        letter-spacing: 0.21px;
        line-height: 32px;
    `}
`;

export const heading5Theme = () => `
    font-family: ${Fonts.roboto};
    font-size: 16px;
    letter-spacing: 0.17px;
    line-height: 20px;
    ${commonCss}

    ${breakpoint('desktop')`
        font-size: 20px;
        letter-spacing: 0.21px;
        line-height: 24px;
    `}
`;

export const heading6Theme = () => `
    font-family: ${Fonts.robotoMedium};
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.18px;
    line-height: 20px;
    ${commonCss}

    ${breakpoint('desktop')`
        font-size: 18px;
        letter-spacing: 0.23px;
        line-height: 24px;
    `}
`;

export const body1Theme = () => `
    font-family: ${Fonts.roboto};
    font-size: 16px;
    letter-spacing: 0.5px;
    line-height: 28px;
    ${commonCss}
`;

export const body2Theme = () => `
    font-family: ${Fonts.roboto};
    font-size: 14px;
    letter-spacing: 0.25px;
    line-height: 20px;
    ${commonCss}
`;

export const subtitle1Theme = () => `
    font-family: ${Fonts.robotoMedium};
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.15px;
    line-height: 16px;
    ${commonCss}

    ${breakpoint('desktop')`
        line-height: 20px;
    `}
`;

export const subtitle2Theme = () => `
    font-family: ${Fonts.robotoMedium};
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.1px;
    line-height: 16px;
    ${commonCss}
`;

export const subtitle3Theme = () => `
    font-family: ${Fonts.robotoLight};
    font-size: 14px;
    letter-spacing: 0.1px;
    line-height: 16px;
    font-weight: 500;
    ${commonCss}
`;

export const captionTheme = () => `
    font-family: ${Fonts.roboto};
    font-size: 12px;
    letter-spacing: 0.4px;
    line-height: 16px;
    ${commonCss}
`;

export const overlineTheme = () => `
    font-family: ${Fonts.robotoMedium};
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 1.67px;
    line-height: 16px;
    ${commonCss}
`;
